import localforage from 'localforage';
import { INDEXED_DB_VERSION } from '../const';

export async function initIndexedDB() {
	const version = await localforage.getItem('INDEXED_DB_VERSION');

	if (version === null || version !== INDEXED_DB_VERSION) {
		await localforage.clear();
		localforage.setItem('INDEXED_DB_VERSION', INDEXED_DB_VERSION);
	}
}
